import { motion } from 'motion/react';
import { TicketingEvent } from '@wbk/api';
import { useWindowScroll } from '@wbk/hooks';
import { useQueue } from '@wbk/queue';
import BuyTicketButton from '@/components/buttons/BuyButton';
import { getEventStatus } from '@/util/events';

type Props = {
  match: TicketingEvent;
  status: ReturnType<typeof getEventStatus>;
};

const MobileStickyBuy = ({ match, status }: Props) => {
  const { y } = useWindowScroll();
  const { isActive, shouldWaitQueue } = useQueue();

  if (isActive || shouldWaitQueue) return null;

  return (
    <>
      <style>{`
        @media (max-width: 1023px) {
          footer {margin-bottom:100px;}
        }
      `}</style>
      <motion.div
        initial={{ y: 0 }}
        animate={{ y: y > 500 ? 0 : 100 }}
        className='fixed bottom-0 left-0 z-20 w-full border-t border-white/20 bg-secondary px-6 py-4 lg:hidden'
        data-testid='buy-tickets-cta-mobile'
      >
        <BuyTicketButton event={match} eventStatus={status} className='mx-auto !block max-w-md' />
      </motion.div>
    </>
  );
};

export default MobileStickyBuy;
